const baseCompanyApiUrls = "/api/Company";
export const CompanyApiUrls = {
  GetCompanies: `${baseCompanyApiUrls}/GetCompanies`,
  AddCompany: `${baseCompanyApiUrls}/AddCompany`,
  UpdateCompany: `${baseCompanyApiUrls}/UpdateCompany`,
  GetCompanyOverview: `${baseCompanyApiUrls}/OverView`,
  GetArchivedCompany: `${baseCompanyApiUrls}/ArchivedCompany`,
  GetCompany: (companyRowID: string) =>
    `${baseCompanyApiUrls}?companyRowID=${companyRowID}`,
  SaveComment: `${baseCompanyApiUrls}/Comment`,
  GetComment: `${baseCompanyApiUrls}/Comment`,
  CompanySLAInfo: `${baseCompanyApiUrls}/CompanySLAInfo`,
  Search: (companyName: string, totalCount: number) =>
        `${baseCompanyApiUrls}/Search?companyName=${companyName}&totalCount=${totalCount}`,
    SlaReporting: `${baseCompanyApiUrls}/GetCompaniesSLAReport`,
    Link: `${baseCompanyApiUrls}/Link`,
    Menu: `${baseCompanyApiUrls}/Menu`,
    Activity: `${baseCompanyApiUrls}/Activity`,

    ProspectsCount: `${baseCompanyApiUrls}/ProspectsCount`,
    Prospects: `${baseCompanyApiUrls}/Prospects`,
    OnboardingProgress: `${baseCompanyApiUrls}/OnboardingProgress`,
    SubmitOnboarding: `${baseCompanyApiUrls}/SubmitOnboarding`,
    OnboardingRecord: `${baseCompanyApiUrls}/OnboardingRecord`,
    OnboardingWizardState: `${baseCompanyApiUrls}/OnboardingWizardState`,
    OnboardingSopDocument: `${baseCompanyApiUrls}/OnboardingSopDocument`,
    OnboardingExport: `${baseCompanyApiUrls}/OnboardingExport`,
    OnboardingImportRequest: `${baseCompanyApiUrls}/OnboardingImportRequest`,
    // The paired Imperans's reference lists, proxied by the CRM (Epic 6303, Feature CRM3).
    OnboardingReferenceFranchises: (country: string) =>
        `${baseCompanyApiUrls}/Onboarding/Reference/Franchises?country=${encodeURIComponent(country)}`,
    OnboardingReferenceClinics: (country: string) =>
        `${baseCompanyApiUrls}/Onboarding/Reference/Clinics?country=${encodeURIComponent(country)}`,
    OnboardingSubmissionPlan: `${baseCompanyApiUrls}/OnboardingSubmissionPlan`,
    // Epic 6303, Feature CRM1: the Imperans submission's standing and Try again.
    ImperansSubmission: `${baseCompanyApiUrls}/ImperansSubmission`,
    RetryImperansSubmission: `${baseCompanyApiUrls}/RetryImperansSubmission`,
    GenerateCompanyCode: `${baseCompanyApiUrls}/GenerateCompanyCode`,
    CompanyCodeAvailability: `${baseCompanyApiUrls}/CompanyCodeAvailability`,
    OnboardingDraft: `${baseCompanyApiUrls}/OnboardingDraft`,
    OnboardingReview: `${baseCompanyApiUrls}/OnboardingReview`,
    OnboardingAcknowledgements: `${baseCompanyApiUrls}/OnboardingAcknowledgements`,
    UpdateClientDetails: `${baseCompanyApiUrls}/UpdateClientDetails`,
    LinkFlag: `${baseCompanyApiUrls}/LinkFlag`,
    DeleteCompany: `${baseCompanyApiUrls}/DeleteCompany`,
    PromoteToOnboarding: `${baseCompanyApiUrls}/PromoteToOnboarding`,
    MarkAsCurrentClient: `${baseCompanyApiUrls}/MarkAsCurrentClient`,

    SavePriceReviewComment: `${baseCompanyApiUrls}/SavePriceReviewComment`,
    RelationshipManagers: `${baseCompanyApiUrls}/RelationshipManagers`,
    UpdateSLAInfo: `${baseCompanyApiUrls}/UpdateSLAInfo`,
    GetSLAInfo: `${baseCompanyApiUrls}/GetSLAInfo`,
};
